import Icon from '../Icon';
import { Wrapper } from './styled';

export default function Button(props: ButtonProps) {
    const { disabled, icon, text, color, ghost = false, onClick } = props;
    return (
        <Wrapper onClick={onClick} disabled={disabled} $color={color} $ghost={ghost}>
            {text}
            {icon && <Icon name={icon} color={color} />}
        </Wrapper>
    );
}
